module.exports = __webpack_public_path__ + "static/media/09.eb915940.jpg";